// src/services/mobileDeviceApi.js
import { apiClient } from "../utils/apiClient";

export const mobileDeviceApi = {
    // List all devices (Admin)
    async list() {
        return await apiClient("MobileDevice/list", { method: "GET" });
    },

    // Admin approve/block/revoke/delete
    async adminAction(userId, deviceId, action) {
        // action: "Approve", "Block", "Delete"
        // Note: Controller expects "Approve", "Block", "Delete"
        return await apiClient("MobileDevice/admin-approve", {
            method: "POST",
            body: { userId, deviceId, action }
        });
    },

    // Generate Pairing Code
    async generatePairingCode(userIdOrOptions, targetDeviceId = null, employeeId = null) {
        const body = typeof userIdOrOptions === "object" && userIdOrOptions !== null
            ? {
                userId: userIdOrOptions.userId || 0,
                employeeId: userIdOrOptions.employeeId || null,
                targetDeviceId: userIdOrOptions.targetDeviceId || null
            }
            : {
                userId: userIdOrOptions || 0,
                employeeId,
                targetDeviceId
            };
        return await apiClient("MobileDevice/generate-pairing-code", {
            method: "POST",
            body
        });
    },

    // Firm Settings
    async getSettings() {
        return await apiClient("FirmSettings", { method: "GET" });
    },

    async updateSetting(key, value) {
        return await apiClient("FirmSettings", {
            method: "POST",
            body: { key, value }
        });
    },

    async getXpassAccessPolicies() {
        return await apiClient("FirmSettings/xpass-access-policy", { method: "GET" });
    },

    async updateXpassAccessPolicies(payload) {
        return await apiClient("FirmSettings/xpass-access-policy", {
            method: "PUT",
            body: payload
        });
    }
};

export default mobileDeviceApi;
